/* eslint-disable */
import { logInfo } from 'commons/logger';
import {
  GET_CART,
  GET_CHECKOUT_SUMMARY,
  GET_CART_SHIPPING_GROUPS,
} from 'mocks/queries';
import { PLACE_ORDER, ERASE_CHECKOUT_DATA } from 'mocks/mutations';
import validateFormatZipCode from 'commons/validateFormatZipCode';

import getZipcode from 'commons/getZipcode';
import parseCartItemErrors from 'commons/parseCartItemErrors';

const getCheckoutRef = () => ({});

const getCart = async (shippingZip, apolloClient) => {
  const response = await apolloClient.query({
    query: GET_CART,
    fetchPolicy: 'network-only',
    context: { noBatch: true },
    variables: {
      shippingZip,
      zipCode: getZipcode(),
      checkoutRef: getCheckoutRef(),
    },
  });
  return response.data.getCart;
};

const getShippingGroups = async (shipping = {}, deliveryInfo = {}) => {
  try {
    const response = await apolloClient.query({
      query: GET_CART_SHIPPING_GROUPS,
      fetchPolicy: 'network-only',
      variables: {
        input: {
          state: shipping.state,
          zipcode: validateFormatZipCode(shipping.zipcode)
            ? shipping.zipcode
            : '',
          delivery_selection: deliveryInfo.delivery_selection,
          production_selection: deliveryInfo.production_selection,
          production_selection_add: deliveryInfo.production_selection_add,
        },
        visitorZip: getZipcode(),
        ...(getCheckoutRef() ? { checkoutRef: getCheckoutRef() } : {}),
      },
    });
    return response.data.getShippingGroups;
  } catch (e) {
    return { errors: [{ message: e.message }] };
  }
};

const placeOrderAPICall = async (
  { cart, email_address, shipping, payment, deliveryInfo, orderSummary },
  quick_checkout_guest,
  apolloClient
) => {
  let order = {
    cart,
    shipping: {
      ...shipping,
      email_address,
    },
    payment,
    deliveryInfo,
    orderSummary,
    visitorZip: getZipcode(),
  };

  try {
    const orderResult = await apolloClient.mutate({
      mutation: PLACE_ORDER,
      variables: {
        order: JSON.stringify(order),
        checkoutRef: getCheckoutRef(),
        quick_checkout_guest,
      },
    });

    logInfo('order result api call', orderResult);

    const response = get(orderResult, 'data.placeOrder', {});

    // erase checkout only if order is successful
    if (response.orderId) {
      await apolloClient.mutate({
        mutation: ERASE_CHECKOUT_DATA,
        variables: {
          checkoutRef: getCheckoutRef(),
        },
      });
    }

    return response;
  } catch (e) {
    return { errors: [{ message: e.message }] };
  }
};

const calculateTotal = async (
  { email_address, shipping, deliveryInfo },
  apolloClient
) => {
  try {
    const { shipping_sms, phone_number, state, zipcode } = shipping || {};
    const {
      delivery_selection,
      production_selection,
      production_selection_add,
    } = deliveryInfo || {};
    const checkoutSummary = await apolloClient.query({
      query: GET_CHECKOUT_SUMMARY,
      variables: {
        checkoutRef: getCheckoutRef(),
        input: {
          delivery_selection,
          production_selection,
          production_selection_add,
          customer_email: email_address,
          shipping_sms: {
            status: shipping_sms ? 1 : 0,
            phone: shipping_sms ? phone_number : null,
          },
          state,
          zipcode,
        },
      },
      fetchPolicy: 'network-only',
    });
    return get(checkoutSummary, 'data.checkoutSummary', {});
  } catch (e) {
    return { errors: [{ message: e.message }] };
  }
};

const placeOrder = async (
  payment,
  event,
  shippingContact,
  quick_checkout_guest,
  apolloClient
) => {
  const clientAuth = null;
  const deliveryInfo = {
    delivery_selection: {},
    production_selection: {},
    production_selection_add: {},
  };
  const email_address = event.billingContact.emailAddress;
  const shipping = {
    first_name: shippingContact?.givenName || '',
    last_name: shippingContact?.familyName || '',
    address: shippingContact?.addressLines[0] || '',
    city: shippingContact?.locality,
    apartment: shippingContact?.addressLines[1] || '',
    company: '',
    state: shippingContact?.administrativeArea,
    zipcode: shippingContact?.postalCode,
    phone_number: shippingContact?.phoneNumber,
    shipping_email: shippingContact?.emailAddress,
    shipping_sms: true,
  };

  // const isValid = await this.validateCheckout();

  // if (!isValid) {
  //   return null;
  // }
  // avo.checkoutStepCompleted({ step: 5 });

  // this.setState({ payment, error: null, placeOrderLoading: true });

  // const { cart } = await this.getCartIssues();
  // if (issues.length) {
  //   this.setState({ placeOrderLoading: false, affirmOrderInProgress: false });
  //   return null;
  // }

  const cart = await getCart(apolloClient);

  // get latest order summary
  const orderSummary = await calculateTotal(
    { email_address, shipping, deliveryInfo },
    apolloClient
  );

  const shippingGroups = await getShippingGroups(shipping, {}, apolloClient);
  logInfo('loggr shipping groups are', shippingGroups);

  const { errors, orderId, customerId } = await placeOrderAPICall(
    {
      email_address,
      shipping,
      payment,
      deliveryInfo: shippingGroups.deliveryInfo,
      orderSummary,
      clientAuth,
      cart: cart.map(item => ({
        name: item.name,
        cart_item_id: item.id,
        product_id: item.product_id,
        quantity: item.quantity,
        sku: item.sku,
        cart_item_errors: item.cart_item_errors,
      })),
    },
    quick_checkout_guest,
    apolloClient
  );

  // if (errors) {
  //   this.showError(errors, 'Failed to place the order. Please try again.');
  // }

  return { orderId, customerId };
};

export default placeOrder;
